import { motion } from "framer-motion";
import { ArrowRight, MessageCircle } from "lucide-react";
import { Reveal } from "./Reveal";
import { IMAGES } from "@/data/content";
import { useBooking } from "@/App";
import { waLink, GENERAL_MESSAGE } from "@/config";

export default function FinalCta() {
  const { openBooking } = useBooking();
  return (
    <section className="relative py-28 sm:py-40 overflow-hidden" data-testid="final-cta-section">
      <img
        src={IMAGES.botanical}
        alt=""
        aria-hidden="true"
        className="absolute inset-0 w-full h-full object-cover"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-forest/85" />
      <div className="relative max-w-3xl mx-auto px-4 sm:px-6 text-center">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.3em] font-bold text-gold mb-6">Begin Today</p>
          <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-ivory leading-[1.12] text-balance">
            Your Health Journey Doesn't Have to Start With Another Monday.
          </h2>
        </Reveal>
        <Reveal delay={0.12}>
          <p className="mt-7 text-lg text-ivory/80 leading-relaxed">
            Start with a conversation. Tell us where you are today.
            <br />
            We'll help you understand where to begin.
          </p>
        </Reveal>
        <Reveal delay={0.2}>
          <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
            <motion.button
              whileHover={{ scale: 1.04, y: -2 }}
              whileTap={{ scale: 0.97 }}
              onClick={openBooking}
              data-testid="final-book-discovery-call-button"
              className="inline-flex items-center gap-2.5 rounded-full bg-gold text-forest px-9 py-4.5 py-4 text-sm font-extrabold tracking-wide shadow-hover hover:bg-amber transition-colors"
            >
              BOOK YOUR FREE 1:1 DISCOVERY CALL <ArrowRight size={16} />
            </motion.button>
            <motion.a
              whileHover={{ scale: 1.04, y: -2 }}
              whileTap={{ scale: 0.97 }}
              href={waLink(GENERAL_MESSAGE)}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="final-whatsapp-button"
              className="inline-flex items-center gap-2.5 rounded-full border border-ivory/35 text-ivory px-9 py-4 text-sm font-bold tracking-wide hover:bg-ivory/10 transition-colors"
            >
              <MessageCircle size={16} /> WHATSAPP AAROGYAM BHARAT
            </motion.a>
          </div>
        </Reveal>
        <Reveal delay={0.3}>
          <p className="mt-9 font-serif italic text-lg text-ivory/70">
            No extreme diets. No perfection required. Just personalised guidance designed around your real life.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
